import React from 'react';
import { Box, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface SectionInfoTooltipProps {
	/** Contenido del tooltip (bloques de Typography, listas, etc.) */
	content: React.ReactNode;
}

/**
 * Ícono de ayuda con tooltip para los títulos de sección del dashboard de ventas.
 * Se coloca junto al título, dentro de un Box inline-flex con gap.
 */
export function SectionInfoTooltip({ content }: SectionInfoTooltipProps): JSX.Element {
	return (
		<Tooltip title={<Box sx={{ p: 0.5, maxWidth: 360 }}>{content}</Box>} placement="top" arrow>
			<InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.disabled', cursor: 'help', flexShrink: 0 }} />
		</Tooltip>
	);
}
